export const countryNameToAbbreviation = {
    Afghanistan: "AF",
    Albania: "AL",
    Algeria: "DZ",
    Andorra: "AD",
    Angola: "AO",
    Antigua_and_Barbuda: "AG",
    Argentina: "AR",
    Armenia: "AM",
    Australia: "AU",
    Austria: "AT",
    Azerbaijan: "AZ",
    Bahamas: "BS",
    Bahrain: "BH",
    Bangladesh: "BD",
    Barbados: "BB",
    Belarus: "BY",
    Belgium: "BE",
    Belize: "BZ",
    Benin: "BJ",
    Bhutan: "BT",
    Bolivia: "BO",
    Bosnia_and_Herzegovina: "BA",
    Botswana: "BW",
    Brazil: "BR",
    Brunei: "BN",
    Bulgaria: "BG",
    Burkina_Faso: "BF",
    Burundi: "BI",
    Cambodia: "KH",
    Cameroon: "CM",
    Canada: "CA",
    Cape_Verde: "CV",
    Central_African_Republic: "CF",
    Chad: "TD",
    Chile: "CL",
    China: "CN",
    Colombia: "CO",
    Comoros: "KM",
    Congo_Democratic_Republic: "CD",
    Congo_Republic: "CG",
    Costa_Rica: "CR",
    Croatia: "HR",
    Cuba: "CU",
    Cyprus: "CY",
    Czech_Republic: "CZ",
    Denmark: "DK",
    Djibouti: "DJ",
    Dominica: "DM",
    Dominican_Republic: "DO",
    Ecuador: "EC",
    Egypt: "EG",
    El_Salvador: "SV",
    Equatorial_Guinea: "GQ",
    Eritrea: "ER",
    Estonia: "EE",
    Eswatini: "SZ",
    Ethiopia: "ET",
    Fiji: "FJ",
    Finland: "FI",
    France: "FR",
    Gabon: "GA",
    Gambia: "GM",
    Georgia: "GE",
    Germany: "DE",
    Ghana: "GH",
    Greece: "GR",
    Grenada: "GD",
    Guatemala: "GT",
    Guinea: "GN",
    Guinea_Bissau: "GW",
    Guyana: "GY",
    Haiti: "HT",
    Honduras: "HN",
    Hungary: "HU",
    Iceland: "IS",
    India: "IN",
    Indonesia: "ID",
    Iran: "IR",
    Iraq: "IQ",
    Ireland: "IE",
    Israel: "IL",
    Italy: "IT",
    Jamaica: "JM",
    Japan: "JP",
    Jordan: "JO",
    Kazakhstan: "KZ",
    Kenya: "KE",
    Kiribati: "KI",
    Korea_North: "KP",
    Korea_South: "KR",
    Kosovo: "XK",
    Kuwait: "KW",
    Kyrgyzstan: "KG",
    Laos: "LA",
    Latvia: "LV",
    Lebanon: "LB",
    Lesotho: "LS",
    Liberia: "LR",
    Libya: "LY",
    Liechtenstein: "LI",
    Lithuania: "LT",
    Luxembourg: "LU",
    Madagascar: "MG",
    Malawi: "MW",
    Malaysia: "MY",
    Maldives: "MV",
    Mali: "ML",
    Malta: "MT",
    Marshall_Islands: "MH",
    Mauritania: "MR",
    Mauritius: "MU",
    Mexico: "MX",
    Micronesia: "FM",
    Moldova: "MD",
    Monaco: "MC",
    Mongolia: "MN",
    Montenegro: "ME",
    Morocco: "MA",
    Mozambique: "MZ",
    Myanmar: "MM",
    Namibia: "NA",
    Nauru: "NR",
    Nepal: "NP",
    Netherlands: "NL",
    New_Zealand: "NZ",
    Nicaragua: "NI",
    Niger: "NE",
    Nigeria: "NG",
    North_Macedonia: "MK",
    Norway: "NO",
    Oman: "OM",
    Pakistan: "PK",
    Palau: "PW",
    Palestine: "PS",
    Panama: "PA",
    Papua_New_Guinea: "PG",
    Paraguay: "PY",
    Peru: "PE",
    Philippines: "PH",
    Poland: "PL",
    Portugal: "PT",
    Qatar: "QA",
    Romania: "RO",
    Russia: "RU",
    Rwanda: "RW",
    Saint_Kitts_and_Nevis: "KN",
    Saint_Lucia: "LC",
    Saint_Vincent_and_the_Grenadines: "VC",
    Samoa: "WS",
    San_Marino: "SM",
    Sao_Tome_and_Principe: "ST",
    Saudi_Arabia: "SA",
    Senegal: "SN",
    Serbia: "RS",
    Seychelles: "SC",
    Sierra_Leone: "SL",
    Singapore: "SG",
    Slovakia: "SK",
    Slovenia: "SI",
    Solomon_Islands: "SB",
    Somalia: "SO",
    South_Africa: "ZA",
    South_Sudan: "SS",
    Spain: "ES",
    Sri_Lanka: "LK",
    Sudan: "SD",
    Suriname: "SR",
    Sweden: "SE",
    Switzerland: "CH",
    Syria: "SY",
    Taiwan: "TW",
    Tajikistan: "TJ",
    Tanzania: "TZ",
    Thailand: "TH",
    Timor_Leste: "TL",
    Togo: "TG",
    Tonga: "TO",
    Trinidad_and_Tobago: "TT",
    Tunisia: "TN",
    Turkey: "TR",
    Turkmenistan: "TM",
    Tuvalu: "TV",
    Uganda: "UG",
    Ukraine: "UA",
    United_Arab_Emirates: "AE",
    United_Kingdom: "GB",
    United_States: "US",
    Uruguay: "UY",
    Uzbekistan: "UZ",
    Vanuatu: "VU",
    Venezuela: "VE",
    Vietnam: "VN",
    Yemen: "YE",
    Zambia: "ZM",
    Zimbabwe: "ZW",
  };
